// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2xobM","errors":"Errors_errors__2zuw1"};